import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Paper, Typography } from "@mui/material";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  ArcElement,
  registerables as registerablesJS,
} from "chart.js";
import { getEmissionTypes, getRecordStatus } from "../../../redux/actions";
import useStyles from "./styles";
import EmissionTypeChart from "./EmissionTypeChart";
import { getCookie } from "../../../services/cookie";
import EmissionTypeChartScopeBasis from "./EmissionTypeChartScopeBasis";

ChartJS.register(...registerablesJS);
ChartJS.register(ArcElement, Tooltip, Legend);

const EmissionChart = (props) => {
  console.log("🧪 EmissionChart RENDERED"); // ✅ Place it here
  const classes = useStyles();
  const dispatch = useDispatch();
  const role = getCookie("role");
  const companyId = getCookie("companyId");
  const emissionData = useSelector(
    (state) => state.dashboard.getEmissionTypes.data
  );
  const recordStatus = useSelector(
    (state) => state.dashboard.getRecordStatus.data
  );

  const emissionDataStatus = useSelector(
    (state) => state.dashboard.getEmissionTypes.status
  );
  const recordStatusStatus = useSelector(
    (state) => state.dashboard.getRecordStatus.status
  );

  useEffect(() => {
    if (
      role === "sustainability_manager" ||
      role === "proxy_sustainability_manager" ||
      role === "read_only_user"
    ) {
      !props.refreshContent &&
        dispatch(getEmissionTypes(props.filter, role, companyId));
    } else {
      !props.refreshContent && dispatch(getRecordStatus(props.filter));
    }
  }, [dispatch, props.filter]);

  useEffect(() => {
    console.log("EmissionChart isConfigurable:", props.isConfigurable);
  }, [props.isConfigurable]);

  return (
    <>
      {role === "sustainability_manager" ||
      role === "proxy_sustainability_manager" ||
      role === "read_only_user" ? (
        <Paper className={classes.containerFullHeight}>
          <Typography className={classes.graphTitle}>
            Emission Types(tonnes)
          </Typography>
          <div className={classes.emissionChart}>
            {emissionData?.length > 0 ? (
              <EmissionTypeChartScopeBasis
                data={emissionData}
                isConfigurable={true}
              />
            ) : emissionDataStatus === "running" ? (
              <div style={{ minHeight: 250 }}>Loading...</div>
            ) : (
              <div style={{ minHeight: 250 }}>No Data Available</div>
            )}
          </div>
        </Paper>
      ) : (
        <Paper className={classes.container}>
          <Typography className={classes.graphTitle}>Record Status</Typography>
          <div className={classes.chart}>
            {recordStatus?.length > 0 ? (
              <EmissionTypeChart data={recordStatus} />
            ) : recordStatusStatus === "running" ? (
              <div style={{ minHeight: 250 }}>Loading...</div>
            ) : (
              <div style={{ minHeight: 250 }}>No Data Available</div>
            )}
          </div>
        </Paper>
      )}
    </>
  );
};

export default EmissionChart;
